var App = App || {};

App.LoanOfficerContactBand = (function ($) {
    "use strict";

    var $LoanOfficerContactBand = $(".loan-officer-contact-band"),
        LoanOfficerContactBandId = $LoanOfficerContactBand.data('contactbandid');

    function init() {
        $LoanOfficerContactBand.on('click', '.loan-officer-contact-band__dismiss', function () {
            dismissLoanOfficerContactBand($LoanOfficerContactBand, LoanOfficerContactBandId);
        });


        setTimeout(updateHeaderSpace, 500);

        if ($(".loan-officer-contact-band").length > 0) {
            $(window).on("resize", updateHeaderSpace);
        }
    }

    function dismissLoanOfficerContactBand($LoanOfficerContactBand, LoanOfficerContactBandId) {
        $LoanOfficerContactBand.slideUp(300); 
        App.Cookies.setItem("LoanOfficerContactBandDismissed-" + LoanOfficerContactBandId, "true", null, "/", null, "true");
        $LoanOfficerContactBand.css("max-height", "0px");
        updateHeaderSpace();
    }

    // change the height of the header spacer to fit one or more alerts
    function updateHeaderSpace() {
        var headerHeight = $(".headernav").height();
        $(".header-spacer").height(headerHeight);
    }

    function LoanOfficerContactBandDismissed(LoanOfficerContactBandId) {
        return App.Cookies.getItem("LoanOfficerContactBandDismissed-" + LoanOfficerContactBandId) === "true" ? true : false;
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.LoanOfficerContactBand.init();
});